import { render } from "./PerfilAtencion.vue?vue&type=template&id=8b1706ae&scoped=true"
import script from "./PerfilAtencion.vue?vue&type=script&lang=js"
export * from "./PerfilAtencion.vue?vue&type=script&lang=js"

import "./PerfilAtencion.vue?vue&type=style&index=0&id=8b1706ae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b1706ae"]])

export default __exports__